import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {BaseService} from '../base.service';
import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Paging} from '../../models/latipay/paging.model';
import {Sorts} from '../../models/admin/sorts.model';
import {AppCoupon} from '../../models/latipay/app-coupon.model';
import {AppTransactionMonitor} from '../../models/latipay/app-transaction-monitor.model';

@Injectable()
export class PolipayReconSettlementResultService extends BaseService implements OnInit {

    constructor(public http: HttpClient) {
        super('polipay-recon-settlement-result', http);
    }

    ngOnInit(): void {

    }

    getAllBankResultByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }


        const embeddedStr = '&embedded=transaction,bnz-data,kiwi-data&f_errorCode=0&f_errorCode_op=IN';
        return this.http.get(`${this.url}?${paging.getPagingStr()}${embeddedStr +  searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllBankIssueResultByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }

        const embeddedStr = '&embedded=transaction,bnz-data,kiwi-data&f_errorCode=B110&f_errorCode=B210&f_errorCode=B310&f_errorCode=K110&f_errorCode=K210&f_errorCode=K310';
        return this.http.get(`${this.url}?${paging.getPagingStr()}${embeddedStr +  searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }



    getAllBankRfResultByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }


        const embeddedStr = '&embedded=transaction,statement-item&f_statementItem.sub_transaction_type=GatewayNppReceivableRefund&f_errorCode=0';
        return this.http.get(`${this.url}?${paging.getPagingStr()}${embeddedStr +  searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllBankRfIssueResultByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }

        const embeddedStr = '&embedded=transaction,statement-item&f_errorCode=B617&f_errorCode=B717&f_errorCode=B917';
        return this.http.get(`${this.url}?${paging.getPagingStr()}${embeddedStr +  searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }
    getAllBankAbResultByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }


        const embeddedStr = '&embedded=transaction,statement-item&f_statementItem.sub_transaction_type=GatewayNppDirectCredit&f_errorCode=0';
        return this.http.get(`${this.url}?${paging.getPagingStr()}${embeddedStr +  searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllBankAbIssueResultByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }

        const embeddedStr = '&embedded=transaction,statement-item&f_errorCode=B317&f_errorCode=B417&f_errorCode=B517&f_errorCode=B1017';
        return this.http.get(`${this.url}?${paging.getPagingStr()}${embeddedStr +  searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }



    getAllCouponByBusinessIdByPaging(searchCondition: string, businessId: number, sortOprions: Sorts, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        const idStr = '&f_businessId_op==&f_businessId=' + businessId;
        const sortStr = sortOprions.getSortString();
        // this.embeddedStr = '&embedded=coupons-promo';
        return this.http.get(`${this.url}/get-coupons${sortStr}${paging.getPagingStr()}${this.embeddedStr + idStr + searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    createRecon(data: any) {
        return this.http.post(`https://api-admin-v2.latipay.net/apm/autojob/create`, data).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }







    getAllLatipayByPaging(searchCondition: string, paging: Paging) {
        let idSortStr = '&sort=id,desc';
        if (!searchCondition) {
            searchCondition = '';
        }
        const str = '&f_type_op==&f_type=1';
        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition + idSortStr}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    getAllLatipayByMerchantIdByPaging(merchantId: number, searchCondition: string, paging: Paging) {
        let idSortStr = '&sort=id,desc';
        if (!searchCondition) {
            searchCondition = '';
        }
        const str = '&f_merchantId_op==&f_merchantId=' + merchantId;
        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition + idSortStr + str}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    get(id) {
        const embeddedStr = '&embedded=transaction,bnz-data,kiwi-data';
        const str = embeddedStr ? `${id}?${embeddedStr}` : id;
        return this.http.get(`${this.url}/${str}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    updateStatus(id: number | string, value: any) {
        return this.http.put(`${this.url}/update-status/${id}`, value).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    autoRecon() {
        return this.http.get(`${this.url}/auto-recon`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

}
